module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_02@3x-2fd28699f9718ef0c3027460bb11dd13.webp";